import styled from 'styled-components'

export const Tooltip = styled.div`
	position: absolute;
	bottom: -35px;
	left: 50%;
	transform: translateX(-50%);
	background-color: #62656c;
	color: #fff;
	padding: 5px 10px;
	border-radius: 4px;
	font-size: 11px;
	white-space: nowrap;
	opacity: 0;
	visibility: hidden;
	transition: all 0.2s ease-in-out;
	z-index: 10;

	&::before {
		content: '';
		position: absolute;
		top: -4px;
		left: 50%;
		transform: translateX(-50%);
		border-left: 5px solid transparent;
		border-right: 5px solid transparent;
		border-bottom: 5px solid #62656c;
	}
`

export const HeaderTop = styled.div`
	background-color: #62656c;
	padding: 10px;
`
export const HeaderTopLinks = styled.div`
	max-width: 1400px;
	margin: 0 auto;
`
export const LinkContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: end;
	gap: 10px;
	flex-wrap: wrap;

	@media (max-width: 425px) {
		gap: 5px;
	}
`
export const LinkItem = styled.div`
	display: flex;
	align-items: center;
	gap: 20px;

	@media (max-width: 768px) {
		gap: 10px;
	}
`
export const LinkText = styled.div`
	font-family: 'e-Ukraine', sans-serif;
	font-weight: 300;
	font-size: 13px;
	color: #fff;

	@media (max-width: 768px) {
		font-size: 11px;
	}

	@media (max-width: 425px) {
	font-size: 10px;
	}


`

export const Header = styled.header`
	width: 100%;
	position: fixed;
	z-index:110;
`

export const HeaderWrappper = styled.div`
	border-bottom: 1px solid #d9d9d9;
	padding: 10px;
	background: #fff;
`
export const HeaderContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	max-width: 1400px;
	margin: 0 auto;
`

export const NotificationHeaderContainer = styled.div`
	max-width: 1400px;
	position: relative;
	width: 100%;
	margin: 0 auto;
	box-sizing: border-box;
    padding: 0 10px;
`
export const HeaderLogo = styled.img`
	cursor: pointer;
`
export const HeaderMenuList = styled.div`
  display: flex;
  align-items: center;
  gap: 40px;

  @media (max-width: 1024px) {
    display: none;
  }
`;

export const MenuListItem = styled.div<{ $active?: boolean; $isDev?: boolean }>`
  font-family: 'e-Ukraine', sans-serif;
  font-weight: 400;
  font-size: 14px;
  cursor: ${props => (props.$isDev ? 'default' : 'pointer')};
  color: ${props => (props.$active ? '#01924F' : '#484848')};
  transition: color 0.3s ease;
  position: relative;
  display: flex;
  align-items: center;

  &::after {
    content: '';
    position: absolute;
    bottom: -27px; 
    left: 0;
    width: 100%;
    height: 2px;
    background-color: #01924f;
    transform: ${props => (props.$active ? 'scaleX(1)' : 'scaleX(0)')};
    transform-origin: left; 
    transition: transform 0.3s ease-in-out;
  }

  &:hover {
    color: #01924f;

    &::after {
      transform: ${props => (props.$isDev ? 'scaleX(0)' : 'scaleX(1)')};
    }
  }

  &:hover ${Tooltip} {
    opacity: ${props => (props.$isDev ? '1' : '0')};
    visibility: ${props => (props.$isDev ? 'visible' : 'hidden')};
    bottom: -40px;
	
  }

  @media (max-width: 1024px) {
    font-size: 12px;

    &::after {
      bottom: -27px;
    }
  }
`;

export const HeaderActions = styled.div`
	display: flex;
	position: relative;
	align-items: center;
	gap: 20px;
`

export const AccessibilityIcons = styled.div`
	padding-top: 5px;
	cursor: pointer;
`

export const UserIconWrapper = styled.div`
	cursor: pointer;
	width: 40px;
	height: 40px;
	border-radius: 50%;
	display: flex;
	align-items: center;
	justify-content: center;
	background: transparent;
	box-shadow: none;
	transition: all 0.2s ease;
	color: #484848;
`

export const DropdownMenu = styled.div<{ $isOpen: boolean }>`
	position: absolute;
	top: 100%;
	left: 0;
	background-color: #fff;
	min-width: 130px;
	box-shadow: 1px 3px 7px 0 rgba(0, 0, 0, 0.25);
	border-radius: 0 8px 8px 8px;

	z-index: 100;
	margin-top: 35px;
	padding: 25px;

	display: flex;
	flex-direction: column;
	gap: 3px;

	opacity: ${props => (props.$isOpen ? '1' : '0')};
	visibility: ${props => (props.$isOpen ? 'visible' : 'hidden')};
	transform: ${props =>
		props.$isOpen ? 'translateY(0)' : 'translateY(-10px)'};
	transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
`

export const ArrowIcon = styled.span<{ $isOpen: boolean; $active?: boolean }>`
	display: inline-block;
	margin-left: 8px;
	transition: transform 0.3s ease;
	transform: ${props => (props.$isOpen ? 'rotate(180deg)' : 'rotate(0deg)')};
	border-left: 5px solid transparent;
	border-right: 5px solid transparent;
	border-top: ${props =>
		props.$active ? '5px solid #01924F' : '5px solid #484848'};
`
export const DropdownItem = styled.div<{ $isDev?: boolean }>`
	font-family: 'e-Ukraine', sans-serif;
	font-weight: 500;
	font-size: 13px;
	line-height: 190%;
	color: #484848;
	transition: color 0.2s ease;

	&:hover ${Tooltip} {
		opacity: ${props => (props.$isDev ? '1' : '0')};
		visibility: ${props => (props.$isDev ? 'visible' : 'hidden')};
		bottom: -40px;
	}
	
	&:hover {
		color: ${props => (props.$isDev ? '#484848' : ' #01924f')};
	}
    
`

export const BurgerButton = styled.button`
	display: none;
	flex-direction: column;
	gap: 5px;
	padding: 4px;
	background: none;
	border: none;
	cursor: pointer;

	span {
		display: block;
		width: 22px;
		height: 2px;
		background: #484848;
		border-radius: 2px;
		transition:
			transform 0.3s ease,
			opacity 0.3s ease;
	}

	&.open span:nth-child(1) {
		transform: translateY(7px) rotate(45deg);
	}
	&.open span:nth-child(2) {
		opacity: 0;
		transform: scaleX(0);
	}
	&.open span:nth-child(3) {
		transform: translateY(-7px) rotate(-45deg);
	}

	@media (max-width: 1024px) {
		display: flex;
	}
`

export const MobileDrawer = styled.div<{ $isOpen: boolean }>`
	display: none;

	@media (max-width: 1024px) {
		display: block;
		max-width: 280px;
		position: absolute;
		top: 100%;
		left: 40px;
		right: 8px;
		background: #fff;
		border-radius: 0 8px 8px 8px;
		box-shadow: 1px 3px 14px 0 rgba(0, 0, 0, 0.18);
		padding: 15px 5px;
		z-index: 200;

		opacity: ${props => (props.$isOpen ? '1' : '0')};
		pointer-events: ${props => (props.$isOpen ? 'auto' : 'none')};
		transform: ${props =>
			props.$isOpen ? 'translateY(0)' : 'translateY(-8px)'};
		transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
	}
`
export const MobileMenuItem = styled.div<{
  $active?: boolean
  $isDev?: boolean
}>`
  padding: 12px 24px;
  font-size: 15px;
  font-family: 'e-Ukraine', sans-serif;
  color: ${props => (props.$active ? '#01924F' : '#484848')};
  cursor: ${props => (props.$isDev ? 'default' : 'pointer')};
  display: flex;
  align-items: center;
  gap: 8px;
  position: relative;
  width: fit-content; 

  &::after {
    content: '';
    position: absolute;
    bottom: 8px; 
    left: 24px;  
    right: 24px; 
    height: 2px;
    background-color: #01924F;
    transform: ${props => (props.$active ? 'scaleX(1)' : 'scaleX(0)')};
    transform-origin: left; 
    transition: transform 0.3s ease;
  }

  &:active {
    color: #01924F;
    
    &::after {
      transform: ${props => (props.$isDev ? 'scaleX(0)' : 'scaleX(1)')};
    }
  }
  @media (hover: hover) {
    &:hover {
      color: #01924F;
      &::after {
        transform: ${props => (props.$isDev ? 'scaleX(0)' : 'scaleX(1)')};
      }
    }
  }
`

export const MobileSubItem = styled.div`
	padding: 6px 24px 6px 36px;
	font-size: 14px;
	color: #aaa;
	cursor: pointer;
    transition: color 0.3s ease;

	 &:hover {
      color: #01924F; 
    
    }

`

export const MobileSubDivider = styled.div`
	height: 1px;
	background: #e0e0e0;
	margin: 6px 0;
`


export const MobileOverlay = styled.div`
	position: fixed;
	inset: 0;
	background: rgba(0, 0, 0, 0.4);
	z-index: 105;
`